import { render, staticRenderFns } from "./SendList.vue?vue&type=template&id=deab2904&scoped=true&"
import script from "./SendList.vue?vue&type=script&lang=js&"
export * from "./SendList.vue?vue&type=script&lang=js&"
import style0 from "./SendList.vue?vue&type=style&index=0&id=deab2904&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deab2904",
  null
  
)

export default component.exports